// Oike — what happens when a message to a contact is used from its card (moved unchanged from ContactsSection so the
// unified client file does exactly the same): open the channel with the text, log the activity as Sent, add the person
// to the event when it came from an invitation, activate the company if needed and mark the contact as Contacted.
import { AirtableAPI, TABLE_IDS, CURRENT_USER } from './globals.js';
import { F, linkedIds, updateStakeholderStatus, activateAccountIfNeeded } from './utils.jsx';

export function sendContactMessage({ stakeholder, channel, message, eventId = null, api = null, data = {}, onAddRecord = null, onLogActivity = null }) {

  const name = F(stakeholder, 'Name') || '';
  const email = F(stakeholder, 'Email') || '';
  const phone = F(stakeholder, 'Phone number') || '';
  const linkedin = F(stakeholder, 'LinkedIn') || '';
  let subject = '', body = message;
  if (channel === 'Email') {
    const lines = message.split('\n');
    const subjectIdx = lines.findIndex(l => /^subject:/i.test(l.trim()));
    if (subjectIdx !== -1) {
      subject = lines[subjectIdx].replace(/^subject:\s*/i, '').trim();
      body = lines.slice(subjectIdx + 1).join('\n').trim();
    }
  }
  if (channel === 'WhatsApp' && phone) window.open(`https://wa.me/${String(phone).replace(/[^0-9+]/g, '')}?text=${encodeURIComponent(message)}`, '_blank');
  else if (channel === 'Email' && email) window.open(`https://mail.google.com/mail/?view=cm&to=${encodeURIComponent(email)}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`, '_blank');
  else if (channel === 'LinkedIn' && linkedin) { navigator.clipboard.writeText(message).catch(() => {}); window.open(linkedin, '_blank'); }
  const companyIds = linkedIds(stakeholder, 'Account');
  const outreachFields = {
    'Activity Name': `${channel} to ${name} — ${new Date().toLocaleDateString('en-US')}`,
    'Account': companyIds, 'Stakeholder': [stakeholder.id],
    'Channel': channel, 'Date': new Date().toISOString(),
    'Status': 'Sent', 'Message': message,
    'Notes': 'Sent from Contacts',
    'Logged By': CURRENT_USER?.name || '',
    ...(CURRENT_USER?.role === 'bdr' && CURRENT_USER?.name ? { 'BDR Owner': CURRENT_USER.name } : {}),
    ...(CURRENT_USER?.role === 'cp' && CURRENT_USER?.name ? { 'CP Assigned': CURRENT_USER.name } : {}),
  };
  if (onAddRecord) onAddRecord('outreach', outreachFields);
  const a = api || new AirtableAPI();
  a.createRecord(TABLE_IDS.outreach, outreachFields)
    .then(async () => {
      if (eventId) {
        const ev = data.events?.find(e => e.id === eventId);
        const currentInvited = ev ? linkedIds(ev, 'Stakeholders invited') : [];
        await a.updateRecord(TABLE_IDS.events, eventId, {
          'Stakeholders invited': [...new Set([...currentInvited, stakeholder.id])],
        }).catch(e => console.error('[useMessage] event invite update failed:', e));
      }
      await activateAccountIfNeeded(a, companyIds, data.accounts);
      await updateStakeholderStatus(a, stakeholder.id, 'Contacted', data.stakeholders);
    })
    .then(() => { if (onLogActivity) onLogActivity(); })
    .catch(e => console.error(e));
  }
